import TextTitleItem from "../Data/TextTitleItem";
import SummaryTranslationItem from "../Data/SummaryTranslationItem";
import NumericValueTranslationItem from "../Data/NumericValueTranslationItem";
import ImageAnswerTranslationItem from "../Data/ImageAnswerTranslationItem";
import HeaderAnswerTranslationItem from "../Data/HeaderAnswerTranslationItem";
import {ZooPassOfferingItem} from "../Data/ZooContrib";
import {ZooMemberDetails, ZooMemberLookupResponseDto} from "../Data/TnewMemberDetails";
import { Country } from "../Components/PanelContents/DataFormComponent";
import ConstituentSnapshot from "../Data/ConstituentSnapshot";
import { MemberDataDto } from "../Data/MemberDataDto";



    
interface MemberDataDtoSent extends MemberDataDto {
    renewalYorN?: "Yes" | "No";
}

export default class ZooPassFetch {

    public static getWindowLocationDefaultFetchBase(): string {
        return `${window.location.protocol}//${window.location.host}`;
    }

    public static getTNEWSessionRedirectUrl(fetchBase: string): string {

        if (fetchBase == null || fetchBase === "") {
            fetchBase = ZooPassFetch.getWindowLocationDefaultFetchBase();
        }
        let tnewbase = window.tnewUrl;

        const sharedSessionParams = new URLSearchParams();
        const sharedSessionActionUrl = `${fetchBase}/api/tessitura/setsession`;
        sharedSessionParams.append("actionUrl", sharedSessionActionUrl);
        sharedSessionParams.append("returnUrl", window.location.href);

        const redirectRedirectUrl = `${tnewbase}/components/sharedsession?${sharedSessionParams.toString()}`;

        return redirectRedirectUrl;
    }
    
    public static getTNEWRedirectUrl(fetchBase: string): string {

        if (fetchBase == null || fetchBase === "") {
            fetchBase = ZooPassFetch.getWindowLocationDefaultFetchBase();
        }
        let tnewbase = window.tnewUrl;

        const redirectParams = new URLSearchParams();
        const redirectRedirectUrl = ZooPassFetch.getTNEWSessionRedirectUrl(fetchBase);
        redirectParams.append("returnurl", redirectRedirectUrl);

        const finalUrl = `${tnewbase}/account/login?${redirectParams.toString()}`;

        return finalUrl;
    }


    public static redirectTNewSession(fetchBase: string): void {
        const redirectUrl = ZooPassFetch.getTNEWSessionRedirectUrl(fetchBase);
        window.location.href = redirectUrl;
    }

    public static redirectTNewLogin(fetchBase: string): void {
        const redirectUrl = ZooPassFetch.getTNEWRedirectUrl(fetchBase);
        window.location.href = redirectUrl;
    }

    public static async setMemberData(fetchBase: string, id: string | null, memberDataDto: MemberDataDtoSent): Promise<{memberLevelNo?: number | null, success: boolean}> {
        try{            
            const result = await fetch(`${fetchBase}/api/tessitura/update-member-data?id=${id}`, {
                'credentials': 'include',
                method: "POST",
                body: JSON.stringify(memberDataDto),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            
            if(result.ok){
                var json = await result.json();
                return Promise.resolve(json);
            }
            
            return Promise.reject(result.statusText);
            
        }catch(e){
            console.warn(e);
            return Promise.reject(e);
        }
        
    }

    public static async getCountries(fetchBase: string): Promise<Country[]> {
        try {
            const response = await fetch(`${fetchBase}/api/tessitura/countries`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const countries: Country[] = await response.json();
            return countries;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error;
        }        
    }
    
    
    public static async searchRenewalMemberInfo(fetchBase: string, ln: string, membershipId :string): Promise<ZooMemberLookupResponseDto> {
        try {
            const baseUrl = `${fetchBase}/api/tessitura/member-lookup`;
            const params = new URLSearchParams();
            params.set('ln', ln);
            params.set('membershipId', membershipId);
            const response = await fetch(`${baseUrl}?${params.toString()}`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                console.warn(`HTTP error! Status: ${response.status}`);
                return Promise.reject<ZooMemberLookupResponseDto>();
                
            }
            // Parse the JSON body of the response
            return await response.json() as ZooMemberLookupResponseDto;
        } catch (error) {
            console.warn('Fetch failed:', error);
            return Promise.reject<ZooMemberLookupResponseDto>();
        }
    }
    
    public static async fetchMemberInfo(fetchBase: string): Promise<ZooMemberDetails> {
        try {
            const response = await fetch(`${fetchBase}/api/tessitura/member-info`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            return await response.json() as ZooMemberDetails;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }

    public static async isLoggedIn(fetchBase: string): Promise<{loggedIn: boolean, validSession: boolean}> {
        try {
            const response = await fetch(`${fetchBase}/api/tessitura/logged-in`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            return await response.json() as any;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }

    public static async fetchZooPassOfferings(fetchBase: string, culture: string): Promise<Map<string, ZooPassOfferingItem>> {
        try {
            const urlCulture = encodeURIComponent(culture);
            const response = await fetch(`${fetchBase}/api/${urlCulture}/contrib/zoo-pass-offerings`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();

            // Initialize a Map to store the dictionary
            const map = new Map<string, ZooPassOfferingItem>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of Object.entries(data.data)) {
                let item: ZooPassOfferingItem = {
                    // @ts-ignore
                    fetchKey: value.fetchKey,
                    // @ts-ignore
                    title: value.title,
                    member: {
                        y1: {
                            // @ts-ignore
                            name: value.member.y1.name,
                            // @ts-ignore
                            id: value.member.y1.contrib.id,
                            // @ts-ignore
                            amount: value.member.y1.contrib.amount
                        },
                        y2: {
                            // @ts-ignore
                            name: value.member.y2.name,
                            // @ts-ignore
                            id: value.member.y2.contrib.id,
                            // @ts-ignore
                            amount: value.member.y2.contrib.amount
                        },
                        y3: {
                            // @ts-ignore
                            name: value.member.y3.name,
                            // @ts-ignore
                            id: value.member.y3.contrib.id,
                            // @ts-ignore
                            amount: value.member.y3.contrib.amount
                        }
                    },
                    gift: {
                        y1: {
                            // @ts-ignore
                            name: value.gift.y1.name,
                            // @ts-ignore
                            id: value.gift.y1.contrib.id,
                            // @ts-ignore
                            amount: value.gift.y1.contrib.amount
                        },
                        y2: {
                            // @ts-ignore
                            name: value.gift.y2.name,
                            // @ts-ignore
                            id: value.gift.y2.contrib.id,
                            // @ts-ignore
                            amount: value.gift.y2.contrib.amount
                        },
                        y3: {
                            // @ts-ignore
                            name: value.gift.y3.name,
                            // @ts-ignore
                            id: value.gift.y3.contrib.id,
                            // @ts-ignore
                            amount: value.gift.y3.contrib.amount
                        }
                    },
                    lookup: {
                        // @ts-ignore
                        adults: value.lookup.adults,
                        // @ts-ignore
                        children: value.lookup.children,
                        // @ts-ignore
                        guests: value.lookup.guests,
                        // @ts-ignore
                        parking: value.lookup.parking,
                        // @ts-ignore
                        additionalGuests: value.lookup.additionalGuests,
                        // @ts-ignore
                        education: value.lookup.education,
                        // @ts-ignore
                        tour: value.lookup.tour,
                    }
                }

                // @ts-ignore
                map.set(key, item);
            }
            // console.log(map);
            // Return the populated map
            return map;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }

    public static async fetchHeaderAnswers(fetchBase: string, culture: string): Promise<Map<string, HeaderAnswerTranslationItem>> {
        try {
            const urlCulture = encodeURIComponent(culture);
            const response = await fetch(`${fetchBase}/api/${urlCulture}/translation/header-answers`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();

            // Initialize a Map to store the dictionary
            const map = new Map<string, HeaderAnswerTranslationItem>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of Object.entries(data.data)) {
                // @ts-ignore
                const item = new HeaderAnswerTranslationItem(value.fetchKey, value.title, value.description, value.headerText);
                map.set(item.fetchKey, item);
            }
            // Return the populated map
            return map;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }

    /**
     * Fetch Image Answers
     * @param fetchBase - protocol and domain - may be empty when testing in the same environment
     * @param culture - en-US or any others supported
     */
    public static async fetchImageAnswers(fetchBase: string, culture: string): Promise<Map<string, ImageAnswerTranslationItem>> {
        try {
            const urlCulture = encodeURIComponent(culture);
            const response = await fetch(`${fetchBase}/api/${urlCulture}/translation/image-answers`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();

            // Initialize a Map to store the dictionary
            const map = new Map<string, ImageAnswerTranslationItem>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of Object.entries(data.data)) {
                // @ts-ignore
                const item = new ImageAnswerTranslationItem(value.fetchKey, value.imageUrl, value.title, value.description);
                map.set(item.fetchKey, item);
            }
            // Return the populated map
            return map;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }

    /**
     * Fetch Numeric Values
     * @param fetchBase - protocol and domain - may be empty when testing in the same environment
     * @param culture - en-US or any others supported
     */
    public static async fetchNumericValues(fetchBase: string, culture: string): Promise<Map<string, NumericValueTranslationItem>> {
        try {
            const urlCulture = encodeURIComponent(culture);
            const response = await fetch(`${fetchBase}/api/${urlCulture}/translation/numeric-values`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();

            // Initialize a Map to store the dictionary
            const map = new Map<string, NumericValueTranslationItem>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of Object.entries(data.data)) {
                // @ts-ignore
                const item = new NumericValueTranslationItem(value.fetchKey, value.format0, value.format1, value.formatN);
                map.set(item.fetchKey, item);
            }
            // Return the populated map
            return map;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }

    /**
     * Fetch Summaries
     * @param fetchBase - protocol and domain - may be empty when testing in the same environment
     * @param culture - en-US or any others supported
     */
    public static async fetchSummaryTranslation(fetchBase: string, culture: string): Promise<Map<string, SummaryTranslationItem>> {
        try {
            const urlCulture = encodeURIComponent(culture);
            const response = await fetch(`${fetchBase}/api/${urlCulture}/translation/summaries`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();
            // Initialize a Map to store the dictionary
            const map = new Map<string, SummaryTranslationItem>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of Object.entries(data.data)) {
                // @ts-ignore
                const item = new SummaryTranslationItem(value.fetchKey, value.imageUrl, value.format0, value.format1, value.formatN);
                map.set(item.fetchKey, item);
            }
            // Return the populated map
            return map;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }

    /**
     * Fetch Title Text
     * @param fetchBase - protocol and domain - may be empty when testing in the same environment
     * @param culture - en-US or any others supported
     */
    public static async fetchTitleText(fetchBase: string, culture: string): Promise<Map<string, TextTitleItem>> {
        try {
            const urlCulture = encodeURIComponent(culture);
            const response = await fetch(`${fetchBase}/api/${urlCulture}/translation/title-texts`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();

            // Initialize a Map to store the dictionary
            const map = new Map<string, TextTitleItem>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of Object.entries(data.data)) {
                // @ts-ignore
                const item = new TextTitleItem(value.fetchKey, value.title, value.paragraph, value.aside);
                map.set(item.fetchKey, item);
            }
            // Return the populated map
            return map;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }

    public static async fetchDictionary(fetchBase: string, culture: string): Promise<Map<string, string>> {
        try {
            const urlCulture = encodeURIComponent(culture);
            const response = await fetch(`${fetchBase}/api/${urlCulture}/dictionary?set=zoopass`, {
                'credentials': 'include',
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();

            // Initialize a Map to store the dictionary
            const map = new Map<string, string>();
            // Assuming data.data is an array of key-value pairs
            for (const [key, value] of Object.entries(data.data)) {
                map.set(key, value as string);
            }
            // Return the populated map
            return map;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }

    }

    public static async fetchConstituentSnapshot(fetchBase: string): Promise<ConstituentSnapshot> {
        try {
            const response = await fetch(`${fetchBase}/api/tessitura/constituent-snapshot`, {
                'credentials': 'include',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON body of the response
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Fetch failed:', error);
            throw error; // rethrow the error to handle it further up
        }
    }
    }
